function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "FavouriteSelected"
}, "Favorite selected");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.88994 14.9957C3.83231 14.9879 3.77679 14.9682 3.72668 14.9378C3.67657 14.9074 3.63289 14.867 3.59823 14.8189C3.56337 14.7704 3.53815 14.7154 3.52403 14.6569C3.50992 14.5983 3.50717 14.5375 3.51596 14.4779L4.16649 9.99548L1.12913 6.77728C1.07198 6.71777 1.03166 6.64329 1.01254 6.5619C0.993417 6.4805 0.996209 6.39527 1.02061 6.31539C1.04417 6.23585 1.08874 6.16464 1.14932 6.10972C1.20991 6.05481 1.28413 6.01836 1.36367 6.00446L5.62274 5.27734L7.60992 1.24782C7.64536 1.17346 7.7003 1.11083 7.76852 1.06702C7.83673 1.02322 7.91549 1 7.99586 1C8.07623 1 8.15499 1.02322 8.22321 1.06702C8.29143 1.11083 8.34637 1.17346 8.3818 1.24782L10.369 5.27734L14.628 6.00446C14.7084 6.01689 14.7838 6.05226 14.8457 6.10658C14.9075 6.16089 14.9534 6.23198 14.9781 6.31178C15.0034 6.39201 15.0069 6.47786 14.988 6.55996C14.9692 6.64206 14.9288 6.71724 14.8713 6.77728L11.834 9.99548L12.4903 14.4779C12.502 14.56 12.4919 14.6438 12.4611 14.7205C12.4303 14.7972 12.3799 14.8638 12.3153 14.9133C12.2512 14.9621 12.175 14.9915 12.0956 14.9981C12.0161 15.0047 11.9364 14.9882 11.8655 14.9506L8.00432 12.9058L4.14315 14.9506C4.06584 14.992 3.97808 15.0079 3.89169 14.9963L3.88994 14.9957Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.2
});

function SvgFavouriteSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteSelected);
export default __webpack_public_path__ + "static/media/FavouriteSelected.63c00c2b0e8efdfb5b690d31cb1d9907.svg";
export { ForwardRef as ReactComponent };